import { castToOption } from 'src/helpers';

export enum Country {
  Usa = 'US',
  Canada = 'CA',
}

export const COUNTRY_NAME: Record<Country, string> = {
  [Country.Usa]: 'United States',
  [Country.Canada]: 'Canada',
};

export const COUNTRY_OPTIONS = castToOption(Country, COUNTRY_NAME);
